import React from 'react';
import SeoDatoCMS from '../../Layout/SeoDatocms';
import TemporalBanner from '../TemporalBanner/TemporalBanner';

const MaintenanceMode = ({ page, favicon }) => {
  return (
    <>
      <SeoDatoCMS seo={page.seo} favicon={favicon} />
      <TemporalBanner />
    </>
  );
};

export default MaintenanceMode;
